import React from "react";
import BlogFortyFour from "../component/BlogFortyFour";

function BlogFortyFourContainer() {
  return <BlogFortyFour />;
}

export default BlogFortyFourContainer;
